<form class="reset-password-form-form" novalidate [formGroup]="passwordResetForm" (ngSubmit)="onSubmit($event);">
  <div layout="column">
    <mat-form-field>
      <input #passwordInput type="password" required name="email" matInput formControlName="password" placeholder="{{ 'global.password' | translate }}">
      <mat-label>{{ 'global.password' | translate }}</mat-label>
      <button matSuffix
        tabindex="-1"
        mat-icon-button
        [itfgTogglePasswordVisibility]="passwordInput"
        class="input-suffix-button"
        type="button">
        <mat-icon>visibility</mat-icon>
      </button>
      @if (passwordResetForm.get('password')?.hasError('required') && passwordResetForm.get('password')?.touched) {
        <mat-error>
          {{ 'forms.required' | translate }}
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <input #passwordConfirmInput type="password" required name="password" matInput formControlName="passwordConfirm" placeholder="{{ 'global.confirmPassword' | translate }}">
      <mat-label >{{ 'global.confirmPassword' | translate }}</mat-label>
      <button matSuffix
        tabindex="-1"
        mat-icon-button
        [itfgTogglePasswordVisibility]="passwordConfirmInput"
        class="input-suffix-button"
        type="button">
        <mat-icon>visibility</mat-icon>
      </button>
      @if (passwordResetForm?.hasError('passwordsNotEqual')) {
        <mat-error>
          {{ 'forms.passwordsNotEqual' | translate }}
        </mat-error>
      }
    </mat-form-field>
  </div>

  @if (!showForgotPassword) {
    <button type="submit" mat-raised-button>{{ 'global.login' | translate }}</button>
  }
</form>

<itfg-message [opened]="loginErrored"
  label="{{ 'global.error' | translate }}"
  [sublabel]="loginErrorMessage"
type="error"></itfg-message>